export class FiltrosLicitacoes {
  numero: string;
  ano: string;
  idModalidade: number;
  objeto: string;
  idSituacao: string;

  constructor() {
    this.limpar();
  }

  limpar(): void {
    this.numero = "";
    this.ano = "";
    this.idModalidade = 0;
    this.objeto = "";
    this.idSituacao = "";
  }

  toFormData(): FormData {
    const data = new FormData();
    if (this.ano) data.append("filtroAno", this.ano);
    if (this.numero) data.append("filtroNumero", this.numero);
    if (this.idModalidade > 0)
      data.append("filtroModalidade", String(this.idModalidade));
    if (this.idSituacao)
      data.append("filtroSituacao", this.idSituacao);
    if (this.objeto) data.append("filtroObjeto", this.objeto);
    return data;
  }

  toQueryString(): string {
    let retorno = "";
    if (this.ano) retorno += "&filtroAno=" + this.ano;
    if (this.numero) retorno += "&filtroNumero=" + this.numero;
    if (this.idModalidade > 0)
      retorno += "&filtroModalidade=" + String(this.idModalidade);
    if (this.idSituacao)
      retorno += "&filtroSituacao=" + this.idSituacao;
    if (this.objeto) retorno += "&filtroObjeto=" + this.objeto;
    return retorno;
  }
}
